export default function Playground() {
  return (
    <div className="p-4">
      <h1>Playground</h1>
      <p>Playground page placeholder</p>
    </div>
  );
}